var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMetricsLeftToggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129 625"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%",
    filterUnits: "objectBoundingBox",
    id: "metrics-left-toggle_svg__a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-2.4%",
    y: "-5.2%",
    width: "104.9%",
    height: "110.3%",
    filterUnits: "objectBoundingBox",
    id: "metrics-left-toggle_svg__b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "107.469%",
    x2: "0%",
    y2: "-2.569%",
    id: "metrics-left-toggle_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#081125",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A5668",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.566,
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#80AFE5",
    opacity: 0.702,
    filter: "url(#metrics-left-toggle_svg__a)",
    cx: 91,
    cy: 29,
    r: 15
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#7DABE0",
    strokeWidth: 3,
    opacity: 0.557,
    filter: "url(#metrics-left-toggle_svg__b)",
    x: 1.5,
    y: 1.5,
    width: 120,
    height: 55,
    rx: 27.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.25 58c0 303.459.083 490.644.25 561.557",
    stroke: "url(#metrics-left-toggle_svg__c)",
    strokeWidth: 3,
    strokeLinecap: "square",
    transform: "matrix(-1 0 0 1 126 3)"
  }))));
}

export default "data:image/svg+xml;base64,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";
export { SvgMetricsLeftToggle as ReactComponent };